import guideArticleCard from '@/guide/components/guidearticlecard/guidearticlecard.vue';
import guideHubSideContent from '@/guide/components/guidehubsidecontent/guide-hub-sidecontent.vue';
import guidePaginate from '@/guide/components/guidepaginate/guide-paginate.vue';
import guideWelcome from '@/guide/components/guidewelcome/guide-welcome.vue';
import mvtDropdownList from '@/common/components/mvtdropdownlist/mvt-dropdownlist.vue';

import { mapGetters } from 'vuex';

export default {
    name: 'guideHub',
    props: ['type'],
    components: {
        mvtDropdownList,
        guideWelcome,
        guideArticleCard,
        guideHubSideContent,
        guidePaginate,
    },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb', 'getOfficeInfo']),
        ...mapGetters('guide', ['guide']),
        geo() {
            return this.guide.geo;
        },
        noResults() {
            if (!this.guide.articles || !this.guide.articles.length) {
                return `There is no article about this ${(this.geo.geoType || 'area').toLowerCase()}`;
            }
        },
        getHubData() {
            if (this.geo.geoType === 'CITY') {
                return {
                    title: this.guide.pageHeading,
                    subtitle: 'Browse within the city',
                    image: this.guide.heroImage,
                    msp: this.geo.cityPath,
                    trends: this.geo.cityPath + 'market-trends/',
                    hubName: this.geo.city,
                    subhubName: "City Guide",
                    neighHubs: this.guide.neighHubs,
                    homesForSale: this.guide.homeForSaleNearByCity,
                    postalCodeHubs: this.guide.postalCodeInCity
                };
            } else if (this.geo.geoType === 'NEIGHBORHOOD') {
                return {
                    title: this.guide.pageHeading,
                    subtitle: 'Browse within the neighborhood',
                    image: this.guide.heroImage,
                    msp: this.geo.neighborhoodPath,
                    trends: this.geo.neighborhoodPath ? this.geo.neighborhoodPath + 'market-trends/' : '',
                    hubName: this.geo.neighborhood,
                    subhubName: " Neighborhood Guide",
                    homesForSale: this.guide.neighborhoods,
                };
            }
        },
        officeData() {
            return this.getOfficeInfo[`${this.geo.cityCode}-${this.geo.stateCode}`]
        },
        getNavigationData() {
            var navigate = [
                { href: this.glb.appUrl, text: 'Movoto Real Estate' }
            ];
            this.geo.statePath && navigate.push({ href: this.glb.appUrl + this.geo.statePath, text: this.geo.stateFullName });
            this.geo.cityPath && navigate.push({ href: this.glb.appUrl + this.geo.cityPath, text: this.geo.city });
            this.geo.neighborhoodPath && navigate.push({ href: this.glb.appUrl + this.geo.neighborhoodPath, text: this.geo.neighborhood });
            return navigate;
        }
    }
};